export default __webpack_public_path__ + "static/media/PatientRegistration.ec3f42b9.svg";